import { Injectable } from '@angular/core';
import { ApiService } from './api.base.service';
import { IWService } from '../iw.service';
import { DocumentFile } from '../../models/document-file-model';
import { DocumentProcess } from '../../models/document-process.model';
import { DocumentProcessTo } from '../../models/document-process-to.model';

@Injectable({ providedIn: "root" })
export class DocumentUploadService {
  baseUrl = "api/documentupload";

  constructor(private apiService: ApiService, private iwService: IWService) { }

    //ENDPOINT DE CARGA EN WEB
  public async upload(documentProcess: DocumentProcess): Promise<void> {
      return await this.apiService.post(`${this.baseUrl}/uploadFromWeb/`, documentProcess);
    }

  public async loadDocumentProcessToOptions(): Promise<DocumentProcessTo[]> {
      return await this.apiService.get<DocumentProcessTo[]>(`${this.baseUrl}/loadDocumentProcessToOptionsList`);
  }
    /*TODO: lOG EN FRONT*/
    /* WEB USERBYORGANIZATIONID*/
    /*SINTRA. NULL*/

}
